const state = {
  sales: [],
  sale: [],
  getSaleLoading: false
};

export default {
  namespaced: true,
  state,
  mutations: {
    setSales(state, sales) {
      state.sales = sales;
    },
    setPlainSales(state, sales) {
      state.plainsales = sales;
    },
    setSale(state, sale) {
      state.sale = sale;
    },
    setGetSaleLoading(state, loading) {
      state.getSaleLoading = loading;
    }
  },
  actions: {
    fetchSales({ commit, rootState }, payload) {
      const { dontPaginate, filter, page, customer_name, paginationcount } = payload;
      if (!!dontPaginate || typeof dontPaginate === 'undefined') {
        commit('SET_LOADING', true, { root: true });
        if (!!customer_name || typeof customer_name === 'undefined') {
          return axios
            .get('api/v1/sale', {
              params: {
                page: page,
                filter: filter,
                customer_name: customer_name,
                paginationcount: paginationcount
              }
            })
            .then(response => {
              commit('setSales', response.data);
            })
            .catch(error => {
              if (error.response.status == 403) {
                commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data['message'],
                    color: 'error'
                  },
                  { root: true }
                );
              }
            })
            .finally(() => {
              commit('SET_LOADING', false, { root: true });
            });
        }
        return axios
          .get('api/v1/sale', {
            params: { page: page, filter: filter, paginationcount: paginationcount }
          })
          .then(response => {
            commit('setSales', response.data);
            console.log('BB');
          })
          .catch(error => {
            if (error.response.status == 403) {
              commit(
                'SET_SNACK_BAR',
                {
                  message: error.response.data['message'],
                  color: 'error'
                },
                { root: true }
              );
            }
          })
          .finally(() => {
            commit('SET_LOADING', false, { root: true });
          });
      } else {
        return axios.get('api/v1/sale', { params: { paginate: 0 } }).then(response => {
          commit('setPlainSales', response.data);
        });
      }
    },
    getSale({ commit }, payload) {
      commit('setGetSaleLoading', true);
      return axios
        .get(`api/v1/sale/${payload.id}`)
        .then(response => {
          commit('setSale', response.data);
        })
        .catch(error => {
          if (error.response.status == 403) {
            commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
            commit('setSale', {});
          }
        })
        .catch(error => {
          if (error.response.status == 404) {
            commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
            commit('setSale', {});
          }
        })
        .finally(() => {
          commit('setGetSaleLoading', false);
        });
    }
  }
};
